//
// SASReportConfiguration.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/BIRDModel";
import "../controllers/interactions/NavigationContext";
import "../models/transport/cachedReport/CachedReportURL";
import "./ReportParameterValue";
import "./mediaTarget/WindowSize";
import "@sas-dvr/ltjs-commons/maps/MapConnectionInfo";
import "./BIRDPortableViewFactory";
import "@sas-dvr/ltjs-commons/resources/images/ImageCache";
import "./MaxRowsLimit";
import "../controllers/metadata/MetaDataQueryMode";
import "./ViewSet";

var SASReportConfiguration = createModule("BIRD::SASReportConfiguration", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        useReadOnlyMode: 2,
        loadDataForCurrentSectionOnly: 2,
        birdPortableViewFactory: 1,
        generateReportResponseXMLFileName: 7,
        interactive: 2,
        allowFirstTimeDataRequery: 2,
        imageCache: 1,
        sectionHeaderHeight: 3,
        useSingleThreadMode: 2,
        enableInteractiveData: 2,
        cachedReportURLs: [1],
        windowSize: 4,
        enableStackContainerOptimization: 2,
        maxRowsLimits: [1],
        enableUndoRedo: 2,
        metaDataQueryMode: 4,
        doVisualStyleOverride: 2,
        rejectInvalidReportXML: 2,
        fullyQualifiedPathToBIRDReportDirectory: 7,
        useOfflineMode: 2,
        transportURL: 7,
        reportStateFileName: 7,
        parameterValues: [1],
        stateDirectory: 7,
        contentKey: 7,
        enableWebContent: 2,
        mapConnectionInfo: 1,
        reportUri: 7,
        offlinePackageUrl: 7,
        viewSet: 1,
        comparisonEpsilon: 6,
        restoreControllerState: 2,
        useGTLGridView: 2,
        useDefaultGTLDataTips: 2,
        reportFileName: 7,
        reportCSSOverideFile: 7,
        navigationContext: 1,
        maximumNumberOfSectionsInMemory: 4,
        restoreUserState: 2,
        getReportResponseXMLFileName: 7,
        showEmptyRowsAndColumns: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SASReportConfiguration;
